import store from "@/store";
import apiManager from "@/api-manager";

export const saveAccessTokenFromResponse = (response) => {
  const accessToken = response.data.access;
  store.commit("setAccessToken", "Bearer " + accessToken);
};

let isRefreshing = false;
let refreshPromise = null;

export const refreshAccessToken = async () => {
  if (isRefreshing) return refreshPromise;

  isRefreshing = true;

  refreshPromise = (async () => {
    try {
      const response = await apiManager.refreshToken({
        axiosConfig: { withCredentials: true }
      });

      if (!response || response.status >= 400) {
        forceLogout();
        throw new Error(response.data.detail);
      }

      saveAccessTokenFromResponse(response);
      return response;
    } catch (err) {
      forceLogout();
      throw err;
    } finally {
      isRefreshing = false;
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};

export const forceLogout = () => {  
  store.commit("setAccessToken", null);
  window.localStorage.removeItem("adminGroups");
  window.localStorage.removeItem("username");
  window.location.href = "#/login";
};